/* eslint-disable no-unused-vars */
// Pub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
// i18n
import { i18n } from "@i18n";
import { api_content_edit } from "@/pptjs/api/api_optimize.js";

//edit email
export function content_edit(input) {

  // 调用接口
  var params = {
    taskType: "task_ppt_edit",
    inputText: input.text,
    EmailBody: input.currentEmailBody ? input.currentEmailBody : "",
    TextLength: (input.taskType.id == "optimize_menu_length")
      ? input.taskType.title : "中等",
    WriteStyle: (input.taskType.id == "optimize_menu_style")
      ? input.taskType.title : "专业的"
  };

  api_content_edit(params).then(
    (response) => {
      handleChatGPTOpenAIResponse(response);
    },
    (error) => {
      handleChatGPTOpenAIError(error);
    }
  );
}

async function handleChatGPTOpenAIResponse(response) {
  if (response.data != null && response.data.Code == 0 && response.data.Result != null) {
    let content = response.data.Result.Content;
    if (content != null && content != "") {
      if (response.data.Result.TaskType == "task_ppt_edit") {
        // 把返回内容显示出来
        publish(
          gptPubIds.pubId_Local_Addin_SystemLog,
          content.replace(/\n/g, "<br />")
        );
        localStorage.setItem("currentMessage", content.replace(/\n/g, "\n\n"))
      }
    }
  } else {
    publish(gptPubIds.pubId_Local_Gpt_Processing_Fail, i18n.t("ppt_add_in_main.server_general_error_message"));
  }
}

function handleChatGPTOpenAIError(error) {
  if (error) {
    publish(gptPubIds.pubId_Local_Gpt_Processing_Fail, i18n.t("ppt_add_in_main.server_general_error_message"));
  }
}